import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Value, Block, Inline, Mark, Text } from 'slate';

var Serializer =
/*#__PURE__*/
function () {
  function Serializer(serializers, options) {
    var _this = this;

    _classCallCheck(this, Serializer);

    _defineProperty(this, "serializeNode", function (node) {
      if (Text.isText(node)) {
        return node.marks.reduce(function (memo, mark) {
          var serializer = _this.serializers[mark.type];

          if (serializer) {
            return serializer(_objectSpread({
              node: mark,
              children: memo,
              next: _this.serializeNode
            }, _this.options));
          }

          return memo;
        }, node.text);
      }

      var padding = ' '.repeat(node.getIn(['data', 'depth'], 0) * 4);
      var children;

      if (node.nodes) {
        children = node.nodes.map(_this.serializeNode).join('');
      }

      var serializer = _this.serializers[node.type];

      if (serializer) {
        var result = serializer(_objectSpread({
          node: node,
          children: children,
          next: _this.serializeNode
        }, _this.options));
        if (result !== undefined) return "".concat(padding).concat(result);
      }

      if (Mark.isMark(node) || Inline.isInline(node)) {
        return children;
      } else if (Block.isBlock(node) || Block.isBlockList(node.nodes)) {
        return "".concat(padding).concat(children.trimEnd()).concat(_this.options.delimiter);
      }
    });

    this.serializers = serializers;
    this.options = options;
    this.options.delimiter = typeof options.delimiter === 'string' ? options.delimiter : '\n\n';
  }

  _createClass(Serializer, [{
    key: "serialize",
    value: function serialize(value) {
      return this.serializeNode(value.document);
    }
  }]);

  return Serializer;
}();

export default function markdownSerializer(editor, options) {
  return function serialize(fragment) {
    var _editor$getSerializin = editor.getSerializingRules(),
        serializers = _editor$getSerializin.markdown;

    var serializer = new Serializer(serializers, options);
    var value = Value.create({
      document: fragment.document || fragment
    });
    return serializer.serialize(value);
  };
}